module.exports = __webpack_public_path__ + "img/ashinoko_yuransen.a96c72f8.jpg";